// extracted by mini-css-extract-plugin
export default {"Label":"InputWithLabel_Label__xWwaH","Error":"InputWithLabel_Error__xXbSJ"};